import React from 'react';
import { TouchableOpacity } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import Image from '../Image';
import icons from './icons';
import { useStyle } from './style';
const Icon = ({ name = '', uri = '', customStyle = {}, scalable, style: outerStyle, onPress, }) => {
    const { style } = useStyle({ name, customStyle, scalable });
    const { mode } = useTheme();
    const _uri = React.useMemo(() => {
        if (uri) {
            return uri;
        }
        else if (name) {
            if (icons[name]) {
                return (icons[name][mode + 'Url'] ||
                    icons[name][mode + 'PngUrl'] ||
                    '');
            }
            else {
                console.warn(`无效的name: ${name}, 可用的图标参考: https://kid.corp.kuaishou.com/kid/icon/collections/all?businessId=26`);
            }
        }
        else {
            console.warn('请传入有效的图标uri或name');
            return '';
        }
    }, [name, uri, mode]);
    return typeof onPress === 'function' ? (React.createElement(TouchableOpacity, { activeOpacity: 1, testID: "IconTouchableOpacity", onPress: onPress },
        React.createElement(Image, { testID: "IconImage", style: [style.icon, outerStyle], source: { uri: _uri }, resizeMode: 'contain', tintColor: style.icon.tintColor }))) : (React.createElement(Image, { testID: "IconImage", style: [style.icon, outerStyle], source: { uri: _uri }, resizeMode: 'contain', tintColor: style.icon.tintColor }));
};
export { Icon };
